import { useTranslation } from "react-i18next";
import { withAccessToken } from "../services/http";
export default function AttachmentList({ attachments = [] }) {
  const { t } = useTranslation();
  if (!attachments.length) return null;
  const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:4000/api").replace(/\/$/, "");
  const formatSize = bytes => bytes < 1024 ? bytes + " B"
    : bytes < 1024 * 1024 ? (bytes / 1024).toFixed(1) + " KB"
    : (bytes / (1024 * 1024)).toFixed(1) + " MB";
  return (
    <section className="attachments-section">
      <h4>{t("attachments.title")} ({attachments.length})</h4>
      <div className="attachments-list">
        {attachments.map(attachment => (
          <div key={attachment.id} className="attachment-item">
            <a className="attachment-link"
              href={withAccessToken(apiUrl + "/attachments/" + attachment.id + "/view")}
              target="_blank" rel="noopener noreferrer">
              {attachment.filename}
            </a>
            <span className="attachment-size">({formatSize(attachment.size)})</span>
            <a href={withAccessToken(apiUrl + "/attachments/" + attachment.id + "/view")} target="_blank" rel="noopener noreferrer">{t("attachments.open")}</a>
            <a href={withAccessToken(apiUrl + "/attachments/" + attachment.id + "/download")} download={attachment.filename}>{t("attachments.download")}</a>
          </div>
        ))}
      </div>
    </section>
  );
}
